const RELOADED_AT_KEY = 'chunkReloadAt';

// A lazy chunk that fails to load (network blip, or a deploy removed it) stays failed until the page loads again,
// so reload once. A failure on the page that reload produced shows the error page instead of looping.
export const claimChunkReload = (
  getStorage: () => Pick<Storage, 'getItem' | 'setItem'>,
  pageLoadedAt = performance.timeOrigin,
  now = Date.now()
) => {
  try {
    const storage = getStorage();
    const reloadedAt = Number(storage.getItem(RELOADED_AT_KEY));
    const isReloadedPage = reloadedAt > 0 && pageLoadedAt - reloadedAt < 10_000; // gap between reload() and the new page's start
    if (isReloadedPage) return false;
    storage.setItem(RELOADED_AT_KEY, String(now));
    return true;
  } catch {
    return false;
  }
};

// Vite's preload helper wraps every lazy import and fires this event when one fails.
export const reloadOnChunkError = () =>
  window.addEventListener('vite:preloadError', () => {
    if (claimChunkReload(() => window.sessionStorage)) window.location.reload();
  });
